import i18n from '@/i18n';
import { useI18n } from 'vue-i18n';

export const useI18nLocalize = () => {
  const { t } = useI18n({ useScope: 'global' });
  const { t: $t, locale } = useI18n({
    useScope: 'local',
    messages: i18n.global.messages.value
  });

  const i18nLocale = (lang: string) => {
    locale.value = lang;
    return { t, $t };
  };

  return {
    i18nLocale
  };
};
